import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
import ShareIcon from "../../images/share-icon.svg";
import MoreIcon from "../../images/more-icon.svg";
import { copyToClipboard } from "@/helpers/clipboard";
import { trackEvent } from "../../services/analytics";

// Audience-first sharing (members / everyone / stop syndicating) only makes
// sense on BLS tenants, where a listing can be members-only. On gitcha.com
// every listing is public, so the owner keeps the original one-click share.

export const ShareIconButton = ({ isBlsTenant, onShare }) => {
  if (isBlsTenant) return null;
  return (
    <a role="button" className="social-content-btn mr-12" onClick={onShare}>
      <img src={ShareIcon} alt="Share" />
    </a>
  );
};

export const ShareMenuItems = ({
  isBlsTenant,
  isSyndicated,
  onShareMembers,
  onShareEveryone,
  onStopSyndicating,
}) => {
  if (!isBlsTenant) return null;
  return (
    <>
      <Dropdown.Item onClick={onShareMembers}>Share with members</Dropdown.Item>
      <Dropdown.Item onClick={onShareEveryone}>
        Share with everyone
      </Dropdown.Item>
      {isSyndicated && (
        <Dropdown.Item onClick={onStopSyndicating}>
          Stop syndicating
        </Dropdown.Item>
      )}
      <Dropdown.Divider />
    </>
  );
};

// Signed-out visitors on a public Want-Listing: a three-dot menu whose only
// item is Share. Touch devices get the native share sheet, everywhere else the
// link is copied. Not rendered on BLS tenants, where a listing can be
// members-only and the owner shares through the audience menu instead.
export const PublicShareMenu = ({ isBlsTenant, url, title, wantAdId }) => {
  if (isBlsTenant) return null;

  const handleShare = async () => {
    if (navigator.share && window.matchMedia?.("(pointer: coarse)").matches) {
      try {
        await navigator.share({ title, url });
        trackEvent({
          name: "gitcha_public_wantad_shared",
          attributes: { wantAdId, method: "native" },
        });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    copyToClipboard(url);
    toast.success("Link copied to clipboard");
    trackEvent({
      name: "gitcha_public_wantad_shared",
      attributes: { wantAdId, method: "copy" },
    });
  };

  return (
    <div className="social-btns-wrap">
      <Dropdown>
        <Dropdown.Toggle
          variant=""
          id="dropdown-basic1"
          aria-label="More actions"
        >
          <img src={MoreIcon} alt="" />
        </Dropdown.Toggle>
        <Dropdown.Menu align="end">
          <Dropdown.Item onClick={handleShare}>Share</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
